import { create } from 'zustand'
import i18n from 'i18next'

const useModalStore = create((set, get) => ({
    isModalConfirmOpen: false,
    confirmCallback: null,
    cancelCallback: null,
    shouldCloseOnOverlayClick: true,
    modalConfirmTitle: "",
    modalConfirmText: "",
    modalConfirmContent: null,
    modalConfirmPrimaryButtonText: "",
    modalConfirmPrimaryButtonDisabled: false,
    setModalConfirmPrimaryButtonDisabled: (value) => set(() => {
        return { modalConfirmPrimaryButtonDisabled: value }
    }),
    modalConfirmPrimaryButtonStyleChangeToDanger: false,
    modalConfirmSecondaryButtonText: "",
    modalConfirmCloseManually: false,
    modalConfirmStyle: {},
    openModalConfirm: ({
        title,
        text,
        content,
        callback,
        cancelCallback,
        modalConfirmPrimaryButtonText,
        modalConfirmPrimaryButtonDisabled,
        modalConfirmPrimaryButtonStyleChangeToDanger,
        modalConfirmSecondaryButtonText,
        shouldCloseOnOverlayClick,
        closeManually,
        style
    }) => set(() => {
        return {
            isModalConfirmOpen: true,
            modalConfirmTitle: title ?? "",
            modalConfirmText: text ?? "",
            modalConfirmContent: content ?? null,
            confirmCallback: callback ?? null,
            cancelCallback: cancelCallback ?? null,
            shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? true,
            modalConfirmPrimaryButtonText: modalConfirmPrimaryButtonText ?? i18n.t("confirm"),
            modalConfirmPrimaryButtonDisabled: modalConfirmPrimaryButtonDisabled ?? false,
            modalConfirmPrimaryButtonStyleChangeToDanger: modalConfirmPrimaryButtonStyleChangeToDanger ?? false,
            modalConfirmSecondaryButtonText: modalConfirmSecondaryButtonText ?? i18n.t("cancel"),
            modalConfirmCloseManually: closeManually ?? false,
            modalConfirmStyle: style ?? {}
        }
    }),
    closeModalConfirm: () => set(() => {
        return { isModalConfirmOpen: false }
    }),

    isModalStartApplyOpen: false,
    openModalStartApply: () => set(() => {
        return { isModalStartApplyOpen: true }
    }),
    closeModalStartApply: () => set(() => {
        return { isModalStartApplyOpen: false }
    }),

    isModalInfoOpen: false,
    modalInfoTitle: "",
    modalConfirmShowSuccessIcon: false,
    modalConfirmShowFailIcon: false,
    modalInfoPrimaryButtonStyleChangeToDanger: false,
    modalInfoButtonText: "",
    modalInfoText: "",
    modalInfoContent: null,
    modalInfoStyle: {},
    modalInfoID: null,
    openModalInfo: ({
        title,
        isShowSuccessIcon,
        isShowFailIcon,
        isShowConfirmBtn,
        modalInfoPrimaryButtonStyleChangeToDanger,
        modalInfoButtonText,
        text,
        content,
        style,
        id,
    }) => set(() => {
        return {
            isModalInfoOpen: true,
            modalInfoTitle: title ?? "",
            modalConfirmShowSuccessIcon: isShowSuccessIcon ?? false,
            modalConfirmShowFailIcon: isShowFailIcon ?? false,
            modalConfirmShowConfirmBtn: isShowConfirmBtn ?? true,
            modalInfoPrimaryButtonStyleChangeToDanger: modalInfoPrimaryButtonStyleChangeToDanger ?? false,
            modalInfoButtonText: modalInfoButtonText ?? "",
            modalInfoText: text ?? "",
            modalInfoContent: content ?? null,
            modalInfoStyle: style ?? {},
            modalInfoID: id ?? null,
        }
    }),
    closeModalInfo: () => set(() => {
        return { isModalInfoOpen: false }
    }),
}))

export default useModalStore;